export const questionVariableTypeCode = {
  amount: "A",
  boolean: "B",
  date: "D",
  integer: "I",
  numeric: "N",
  percent: "P",
  percent6: "P6",
  text: "S",
};
